import Union from '../../category/assets/Union'
import Link from '../../category/assets/Link'
import { SortableHandle } from 'react-sortable-hoc'
import Phrase from '../../../libs/translationsUtils/phrase'
import UserAvatar from '../../User/UserAvatar'

const DragHandle = SortableHandle(() => (
  <span className='knowledge-base_content-list-icon'>
    <Union />
  </span>)
)

const KnowledgeBaseContentList = (props) => (
  <li className='knowledge-base_content-list-item'>
    <DragHandle />
    <div className='knowledge-base_content-list-item--icon'>
      {props.icon}
    </div>
    <div className='knowledge-base_content-list-item-details'>
      <h5 className='knowledge-base_content-list-item-title'>{ props.title }</h5>
      <div className='knowledge-base_content-list-item-metadata'>
        <Phrase p={`knowledge.base.topic.metadata.${props.type}`} />
        <UserAvatar
          disablePopup
          user={{ name: props.author.name, avatar: props.author.avatar, id: 2001 }}
          extraClass='avatar--XS' />
        <span>{props.author.name}</span>
      </div>
    </div>
    <a href={props.communityUrl} target='_blank' className='knowledge-base_content-list-expand-icon'>
      <Link />
    </a>
  </li>
)

export default KnowledgeBaseContentList
